import { trackPageview, trackEvent } from '@xingternal/hops-tracking';
import { FEATURE_SWITCHES } from '@src/constants';

export const TRACKING_CHANNEL = 'wbxts/Automatic_Recruiting';

const hasTrackingFF = (currentUser) =>
  currentUser?.featureSwitches?.includes(FEATURE_SWITCHES.TRACKING_ENABLED);

export const trackPDFStep1Loaded = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackPageview(`${TRACKING_CHANNEL}/create_briefing/step1`, {
      PropChannel: TRACKING_CHANNEL,
      PropFormList: 'wbxts_contact_form_open',
    });
  }
};

export const trackPDFStep2Loaded = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackPageview(`${TRACKING_CHANNEL}/create_briefing/step2`, {
      PropChannel: TRACKING_CHANNEL,
      PropFormList: 'wbxts_contact_form_open',
    });
  }
};

export const trackBriefingCreated = (currentUser, skills) => {
  if (hasTrackingFF(currentUser)) {
    const skillsFormatted = Array.isArray(skills) ? skills.join(';') : '';

    trackPageview(`${TRACKING_CHANNEL}/briefing/created`, {
      PropChannel: TRACKING_CHANNEL,
      PropFormList: 'wbxts_contact_form_sent',
      PropTrackActionList: skillsFormatted,
    });
  }
};

export const trackOnClickSendBriefing = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackEvent(`${TRACKING_CHANNEL}/send_briefing`, {
      PropChannel: TRACKING_CHANNEL,
      PropTrackAction: 'xts_send_briefing_open',
    });
  }
};

export const trackOnClickCancelSendBriefing = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackEvent(`${TRACKING_CHANNEL}/cancel_send_briefing`, {
      PropChannel: TRACKING_CHANNEL,
      PropTrackAction: 'xts_send_briefing_cancel',
    });
  }
};

export const trackOnClickConfirmSendBriefing = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackEvent(`${TRACKING_CHANNEL}/confirm_send_briefing`, {
      PropChannel: TRACKING_CHANNEL,
    });
  }
};

export const trackVisitOnboarding = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackPageview(`${TRACKING_CHANNEL}/onboarding`, {
      PropChannel: TRACKING_CHANNEL,
    });
  }
};

export const trackVisitDashboard = (currentUser) => {
  if (hasTrackingFF(currentUser)) {
    trackPageview(`${TRACKING_CHANNEL}/index`, {
      PropChannel: TRACKING_CHANNEL,
    });
  }
};
